<template lang="pug">
  div.sign-in-card-container(
    v-if="signPlanList.length > 0"
    :class="{ 'disabled': !showSignInCard }"
  )
    .sign-in-card-header
      img.sign-in-card-title(:src="titleIcon" alt="")
      .sign-in-card-desc(v-html="signInTitle")

    //- 签到计划
    .sign-in-card-plan
      template(v-for="(item, index) in signPlanList")
        .sign-in-card-plan-item(
          :class="{ 'sign-in-card-plan-item-disabled': item.signed }"
          :style="{ 'z-index': signPlanList.length - index }"
        )
          img.plan-logo(
            :class="{ 'plan-logo-multiple': item.isMulti }"
            :src="item.icon"
            alt=""
          )
          .plan-amount(v-if="!item.signed") +{{ item.amount }}
          .plan-desc(
            :class="{ 'plan-desc-vip': item.vip && item.signed  }"
          ) {{ item.text }}

    //- 超级会员特权提示
    .sign-in-card-svip-tips(v-if="!currentlyIsVip" @click="goVipPage")
      span.title 超级会员特权：
      span 签到得
      span.highlight 3倍奖励金
      span ，享兑丰富好礼
      img.arrow-icon(
        src="https://m.hellobike.com/resource/gallery/833/tRLfOKT_YQ.png"
        alt=""
      )

    //- vip标签
    .sign-in-card-vip-tag(v-if="currentlyIsVip")
      .vip-tag-text 超级会员x3倍中

    //- 任务弹窗
    TaskPopup(
      :visible="taskPopupVisible"
      :taskInfo="taskPopupInfo"
      @close="handleTaskPopupClose"
      @btnClick="handleTaskPopupBtnClick"
    )
</template>

<script>
import eventBus from '@/const/eventBus';
import { getSignAndRecommend } from '@/api/fuli';
import { getTokenAndKey } from '@/utils';
import { safeJsonStringify, jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import SPM from '../common/spm';
import { signInListAdapter, loadAndShowSignPopup } from '../common/helper';
import { getTaskPopupData } from '../common/task';
import TaskPopup from './task-popup';
import {
  WELFARE_VERSION,
  SIGN_IN_DEFAULT_ICON,
  POPUP_WINDOW_KEY,
  RAKE_BACK_AB,
  FULI_MODULE,
} from '../consts';

export default {
  name: 'SignInCard',
  components: { TaskPopup },
  props: {},
  data() {
    return {
      listLength: 7,
      // 签到计划列表
      signPlanList: [],
      // 是否为vip用户
      currentlyIsVip: false,
      // 重复签到提示
      repeatSignDesc: '',
      // 是否本次签到
      doSignThisTime: false,
      // 签到标题
      titleIcon: '',
      // 是否第一次加载完成
      firstLoaded: false,
      // 翻倍广告id和信息
      doubleInformation: null,
      // 任务弹窗是否显示
      taskPopupVisible: false,
      // 任务列表
      taskList: [],
      // 任务弹窗信息
      taskPopupInfo: {},
    };
  },
  inject: ['taskScene', 'rakeSceneAb', 'popupWindowInfo', 'isPureVersion'],
  computed: {
    // 是否展示新版电商返佣
    showSignInCard() {
      const rakeSceneAb = this.rakeSceneAb();
      return rakeSceneAb !== RAKE_BACK_AB.NEW_V2;
    },
  },
  created() {
    // 初始化签到数据
    this.initData();
  },
  async mounted() {
    eventBus.$on('sendTaskPopupData', (taskList) => {
      this.taskList = taskList;
      if (this.taskPopupVisible) {
        this.handleTaskPopupData({ popupIsShow: true });
      }
    });
  },
  methods: {
    // 处理签到逻辑
    async initData() {
      if (this.firstLoaded) return;
      try {
        const taskScene = this.taskScene();
        // 获取token和城市信息
        const { token } = (await getTokenAndKey()) || {};
        // 获取签到信息
        const result = (await getSignAndRecommend({
          token,
          newWelfare: taskScene === WELFARE_VERSION.NEW_TASK_SCENE_V2,
        })) || {};
        const signInfo = result.data || {};

        if (signInfo) {
          // 触发金币更新
          this.$emit('bounty');
          // 数据发送给红包模块
          eventBus.$emit('videoRedPacketDataSent', signInfo.moduleInfo);
          // 签到数据发送出去
          eventBus.$emit('signInDataSent', signInfo);
          // 处理签到信息
          this.handleSignInfo(signInfo);
          this.firstLoaded = true;

          // 签到模块曝光
          SPM.moduleExpose({
            moduleId: 'Welfare_signmodule',
            contentId: 'Welfare_signmodule',
            businessInfo: {},
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('getSignAndRecommend => error', safeJsonStringify(error));
        // 签到信息处理错误埋点
        SPM.customEventWithPointId({
          pointId: 'apmError_signInfoError',
          businessInfo: {
            errorInfo: safeJsonStringify(error),
          },
        });
      }
    },
    // 处理签到信息
    async handleSignInfo(info) {
      const {
        title,
        bonusList = [],
        currentlyIsVip,
        repeatSignDesc,
        doSignThisTime,
        titleIcon,
        moduleInfo,
      } = info;

      // 处理签到计划列表
      const { signInCardList, signInPopupList } = signInListAdapter(
        bonusList,
      );

      // 处理moduleInfo
      let bannerAdvertisementUnitId = '';
      let bannerTaskRelationCouponInfo = {};

      if (moduleInfo && moduleInfo.length > 0) {
        const signInModule = moduleInfo
          .find((item) => item.moduleKey === FULI_MODULE.welfare_attendance_new);
        if (signInModule) {
          bannerAdvertisementUnitId = signInModule.bannerAdvertisementUnitId || '';
          bannerTaskRelationCouponInfo = signInModule.bannerTaskRelationCouponInfo || {};
        }
      }

      this.handleSignPopup({
        signInPopupList,
        bannerAdvertisementUnitId,
        bannerTaskRelationCouponInfo,
        doSignThisTime,
        currentlyIsVip,
      });

      // 数据更新
      this.signInTitle = this.handletitleStyle(title);
      this.signPlanList = signInCardList;
      this.currentlyIsVip = currentlyIsVip;
      this.repeatSignDesc = repeatSignDesc;
      this.doSignThisTime = doSignThisTime;
      this.titleIcon = titleIcon || SIGN_IN_DEFAULT_ICON;
    },
    // 处理签到弹窗
    async handleSignPopup({
      signInPopupList,
      bannerAdvertisementUnitId,
      bannerTaskRelationCouponInfo,
      doSignThisTime,
      currentlyIsVip,
    }) {
      // 非新用户且当天首次签到
      const { key } = this.popupWindowInfo() || {};
      const isPureVersion = this.isPureVersion();
      if (
        doSignThisTime
        && key === POPUP_WINDOW_KEY.checkin_window
        && signInPopupList.length > 0
      ) {
        const res = await loadAndShowSignPopup({
          isVip: currentlyIsVip,
          signInPopupList,
          bannerAdvertisementUnitId,
          bannerTaskRelationCouponInfo,
          isFirstSign: true,
          isPureVersion,
        });

        this.doubleInformation = null;
        const { action = '' } = res || {};
        switch (action) {
          case 'signInBanner':
            eventBus.$emit('haveFinishSignDoubleAdv');
            break;
          case 'close':
            this.handleTaskPopupData();
            break;
          case 'signInClick':
            this.handleTaskPopupData();
            break;
          default:
            break;
        }
      }

      // 自动签到弹窗曝光埋点
      SPM.customEventWithPointId({
        pointId: 'triggerExpose_signPopup',
        businessInfo: {
          popupKey: key,
        },
      });
    },
    // 处理title样式
    handletitleStyle(title) {
      if (!title) {
        return '';
      }
      return title.replace(/可得(\d{1,})奖励金/g, (index, val) => {
        const [k1, k2] = index.split(val);
        return `${k1}<span style="margin-left: 0.04rem; color: #ff5729;">${val}${k2}</span>`;
      });
    },
    // 跳转会员页
    goVipPage() {
      SPM.clickButton({
        buttonName: 'Welfare_sign_member',
        businessInfo: {},
      });
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/vip/v2/transfer?adsource=fulizhongxin`,
      );
    },
    // 任务弹窗关闭
    handleTaskPopupClose() {
      this.taskPopupVisible = false;
      // 刷新任务列表
      eventBus.$emit('refreshTaskList');
    },
    // 处理任务弹窗数据
    handleTaskPopupData(options) {
      const { popupIsShow } = options || {};
      const { visible, taskInfo } = getTaskPopupData(this.taskList);

      if (!popupIsShow) {
        this.taskPopupVisible = visible;
      }
      if (taskInfo) {
        this.taskPopupInfo = taskInfo;
      }
    },
    // 任务弹窗按钮点击
    async handleTaskPopupBtnClick({ closePopup, info }) {
      this.taskPopupVisible = !closePopup;
      if (info) {
        this.taskPopupInfo = info;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sign-in-card-container {
  position: relative;
  padding: 0.12rem 0.08rem 0.08rem;
  margin-bottom: 0.08rem;
  background-color: #fff;
  border-radius: 0.12rem;

  &.disabled {
    overflow: hidden;
    padding: 0;
    height: 0;
    margin-bottom: 0 !important;
  }

  .sign-in-card-header {
    display: flex;
    align-items: center;
    padding: 0 0.04rem;
  }

  .sign-in-card-title {
    margin-right: 0.08rem;
    width: auto;
    height: 0.22rem;
    vertical-align: bottom;
  }

  .sign-in-card-desc {
    font-size: 0.12rem;
    color: #000;
    line-height: 0.17rem;

    .highlight {
      margin-left: 0.04rem;
      color: #ff5729;
    }
  }

  .sign-in-card-plan {
    display: flex;
    justify-content: space-around;
    margin-top: 0.1rem;
    width: 100%;

    .sign-in-card-plan-item {
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      min-height: 0.45rem;

      &::before {
        content: '';
        position: absolute;
        top: 0.14rem;
        width: 100%;
        transform: translateX(-50%);
        height: 0.02rem;
        background-color: #ffdc76;
        z-index: -1;
      }

      &:first-child::before {
        display: none;
      }
    }

    .plan-logo {
      width: 0.2rem;
      height: 0.2rem;
      vertical-align: bottom;

      &.plan-logo-multiple {
        width: 0.28rem;
        height: 0.2rem;
      }
    }

    .plan-amount {
      transform: translate(-0.02rem, -0.06rem);
      font-family: 'DIN Alternate Bold', sans-serif;
      line-height: 0.14rem;
      color: #996201;
      font-size: 0.11rem;
      text-shadow:
        0 0 0.01rem #fff,
        0 0 0.01rem #fff,
        0 0 0.01rem #fff,
        0 0 0.01rem #fff,
        0 0 0.01rem #fff,
        0 0 0.01rem #fff;
    }

    .plan-desc {
      margin-top: -0.04rem;
      font-size: 0.12rem;
      line-height: 0.15rem;
      color: rgba(90, 96, 102, 0.5);

      &.plan-desc-vip {
        color: #996201;
      }
    }

    .sign-in-card-plan-item-disabled {
      &::before {
        background-color: rgba(90, 96, 102, 0.2);
      }

      .plan-logo {
        transform: translateY(0.04rem);
      }
    }
  }

  .sign-in-card-svip-tips {
    display: flex;
    align-items: center;
    margin-top: 0.1rem;
    padding: 0.05rem 0.08rem;
    background-color: #f2f6fa;
    border-radius: 0.08rem;

    span {
      font-size: 0.12rem;
      line-height: normal;
      color: #6c747a;
    }

    .title {
      color: #242729;
      font-weight: 500;
    }

    .highlight {
      color: #ff5729;
    }

    .arrow-icon {
      margin-left: 0.04rem;
      width: 0.045rem;
      height: 0.09rem;
      vertical-align: bottom;
      opacity: 0.6;
    }
  }

  .sign-in-card-vip-tag {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.02rem 0 0 0.16rem;
    width: 1.14rem;
    height: 0.28rem;
    background-image: url('https://m.hellobike.com/resource/gallery/833/XusSWQVY_Rectangle%203473781%20(1).png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .vip-tag-text {
      font-size: 0.12rem;
      line-height: 0.17rem;
      color: #ac8a24;
    }
  }
}
</style>
